module.exports = __webpack_public_path__ + "static/media/logo-uber-eats.2adc45cd.png";